import React, { FormEventHandler, ReactNode } from 'react';
import { clsx } from 'clsx';
import CardContainer from 'src/components/CardContainer/CardContainer';
import Button from 'src/components/Button/Button';
import EditButtonIcon from 'src/assets/img/edit-button-icon.svg';
import { SaveIcon } from './SaveIcon';

interface EditableCardProps {
  title: string;
  formId: string;
  editMode: boolean;
  disabled: boolean;
  onEdit: () => void;
  onCancel: () => void;
  onSubmit: FormEventHandler<HTMLFormElement>;
  className?: string;
  children: ReactNode;
}

// Generic chrome for an "editable info card": header with an Edit toggle,
// a form body, and a footer with Cancel/Save actions. Card-specific forms
// (user info, company info, ...) plug in as children without duplicating
// this layout.
export const EditableCard = ({
  title,
  formId,
  editMode,
  disabled,
  onEdit,
  onCancel,
  onSubmit,
  className,
  children,
}: EditableCardProps) => (
  <CardContainer className={clsx(className, disabled && 'disabled')}>
    <div className="card-header">
      <div className="title">{title}</div>
      <div className="edit-button-container">
        {!editMode && (
          <Button className="transparent" onClick={onEdit}>
            <span>Edit</span>
            <img src={EditButtonIcon} alt="" />
          </Button>
        )}
      </div>
    </div>
    <div className="card-body">
      <form id={formId} onSubmit={onSubmit}>
        {children}
      </form>
    </div>
    <div className="card-footer">
      {editMode && (
        <div className="action-buttons">
          <Button className="transparent black" onClick={onCancel}>
            Cancel
          </Button>
          <Button type="submit" form={formId} className="green">
            Save
            <SaveIcon />
          </Button>
        </div>
      )}
    </div>
  </CardContainer>
);
